import React from 'react';
import {
  Container,
  // Card,
  // CardBody,
  Spinner,
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import ProfileMain from './components/ProfileMain';
import { ReactTitle } from 'react-meta-tags';
import ProfileTabs from './components/ProfileTabs';

const Profile = ({ user, params, location }) => {
  // const { location } = props;
  const { pathname } = location;
  let currTab = '1';
  if (pathname.substring(pathname.lastIndexOf('/') + 1) === 'emails') currTab = '2';
  return (
    <Container className="px-xs-0 mt-min-15-xs pt-15">
      <ReactTitle title="Legitbee - Mon profil" />
      <div className="profile">
        {
          params.isLoading ? (
            <div className="loaderContainer">
              <Spinner
                color="primary"
                role="status"
                aria-hidden="true"
              />
            </div>
          ) : (
            <ProfileTabs user={user} currTab={currTab} />
          )
        }
      </div>
    </Container>
  );
};

Profile.propTypes = {
  user: PropTypes.shape({}).isRequired,
  params: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default connect(state => ({
  user: state.user,
  params: state.params,
}))(Profile);
